<template>
  <b-card-code title="All lessons " no-body>
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- sorting  -->

        <!-- filter -->
        <b-form-group
          label="Filter"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <div class="d-flex flex-wrap align-items-center">
          <EntityExcelToolbar entity="lessons" class="mr-1 mb-1" @imported="getlessons" />
          <addNewLeson />
        </div>
      </div>
    </b-card-body>

    <b-table
      v-if="lessons.length > 0"
      striped
      hover
      responsive
      class="position-relative"
      :per-page="perPage"
      :items="lessons"
      :fields="fields"
    >
      <template #cell(imageCover)="data">
        <b-avatar :src="data.item.imageCover" />
        <!-- {{ data.title }} -->
      </template>
      <template #cell(Action)="data">
        <!-- <p>
          Using v-html directive: <span v-html="data.item.description"></span>
        </p> -->

        <span>
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <!-- <b-dropdown-item @clieck="">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item> -->
              <duplicatelesson :item="data.item" />

              <editlesson :lesson="data.item" />
              <!-- <b-dropdown-item>
                <feather-icon icon="TrashIcon" class="mr-50 text-danger" />
                <span class="mr-50 text-danger">Delete</span>
              </b-dropdown-item> -->
              <deletelesson
                @deletelessonFromlist="deletelessonFromlist"
                :id="data.item._id"
              />
            </b-dropdown>
          </span>
        </span>
        <!-- {{ data }} -->
        <!-- <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge> -->
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <!-- <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group> -->

      <!-- pagination -->
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="prams.limit"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <template #code>
      <!-- {{ codeKitchenSink }} -->
    </template>
  </b-card-code>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
} from "bootstrap-vue";
// import { codeKitchenSink } from "./code";
import lessonsApi from "@/apiServices/lessonsApi";
import deletelesson from "@/views/lessons pages/delete.vue";
import editlesson from "@/views/lessons pages/edit.vue";
import duplicatelesson from "@/views/lessons pages/duplicate.vue";
import addNewLeson from "@/views/lessons pages/add.vue";
import EntityExcelToolbar from "@/components/EntityExcelToolbar.vue";

export default {
  components: {
    EntityExcelToolbar,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    deletelesson,
    addNewLeson,
    editlesson,
    duplicatelesson,
  },
  data() {
    return {
      prams: {
        sort: "-createdAt",
        page: 1,
        limit: 5,
        title: "",
      },
      options: ["video", "pdf", "powerpoint"],

      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      filter: "",
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "imageCover",
          label: "imageCover",
        },
        { key: "title", label: "Title" },
        { key: "type", label: "type" },
        { key: "description", label: "description" },
        "Action",
      ],
      /* eslint-disable global-require */
      lessons: [],
      /* eslint-disable global-require */
      status: [],
      //   codeKitchenSink,
    };
  },
  created() {
    this.getlessons();
  },
  computed: {},
  mounted() {
    // this.totalRows = this.items.length;
  },
  watch: {
    currentPage() {
      this.prams.page = this.currentPage;

      this.getlessons();
    },
    filter() {
      this.prams.page = this.currentPage;
      this.prams.title = this.filter;

      this.getlessons();
    },
  },
  methods: {
    deletelessonFromlist(id) {
      console.log("hi from parent " + id + "******" + this.lessons.length);
      this.lessons = this.lessons.filter(function (obj) {
        return obj._id != id;
      });
      console.log("hi ******" + this.lessons.length);
    },
    getlessons() {
      if (this.filter == "") {
        delete this.prams.title;
      }
      lessonsApi.getLessons(this.prams).then((response) => {
        this.lessons = [];
        if (response.data) {
          this.lessons = response.data;
          this.currentPage = response.paginationResult?.currentPage;
          this.totalRows =
            response.paginationResult?.numberOfPages * this.prams.limit;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "get All lessons",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      //   this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
